import r from '../Utils/fetch';

const w: any = window;
const getBaseUrl = () => w.API_CONNECTORS_CONFIG_URL || 'http://localhost:8080';

// #region Types

export interface CredentialRequest {
	id: number;
	sku: string;
	skuParent: string;
	status: string;
	createdBy: number;
	createdAt: string;
	expiresAt: string;
	notifyEmails: string[];
	clientName?: string;
	note?: string;
	credentialsId?: string;
	completedAt?: string;
	completedEmail?: string;
	updatedAt: string;
	token: string;
	publicUrl: string;
}

export interface CreateCredentialRequestInput {
	sku: string;
	skuParent: string;
	notifyEmails: string[];
	clientName?: string;
	note?: string;
	expiresInDays?: number;
}

export interface CreateCredentialRequestOutput {
	id: number;
	token: string;
	publicUrl: string;
	expiresAt: string;
	status: string;
}

export interface ListCredentialRequestsResponse {
	requests: CredentialRequest[];
	total: number;
}

// #endregion

// #region Status choices

export const statusChoices = [
	{ id: 'pending', name: 'Pending' },
	{ id: 'completed', name: 'Completed' },
	{ id: 'expired', name: 'Expired' },
	{ id: 'revoked', name: 'Revoked' },
];

export const skuParentChoices = [
	{ id: 'advertiser', name: 'Advertiser' },
	{ id: 'analytics', name: 'Analytics' },
	{ id: 'business', name: 'Business' },
	{ id: 'custom', name: 'Custom' },
	{ id: 'reverse', name: 'Reverse' },
];

// #endregion

// #region API calls

export const listCredentialRequests = (params?: {
	status?: string;
	sku?: string;
	limit?: number;
	offset?: number;
}): Promise<ListCredentialRequestsResponse> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests`,
		method: 'GET',
		data: params,
	});

export const createCredentialRequest = (
	data: CreateCredentialRequestInput
): Promise<CreateCredentialRequestOutput> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests`,
		method: 'POST',
		data,
	});

export const getCredentialRequest = (
	id: number
): Promise<{ request: CredentialRequest; token: string; publicUrl: string }> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests/${id}`,
		method: 'GET',
	});

export const revokeCredentialRequest = (id: number): Promise<{ status: string }> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests/${id}/revoke`,
		method: 'PATCH',
	});

export const deleteCredentialRequest = (id: number): Promise<void> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests/${id}`,
		method: 'DELETE',
	});

export const createSetupSession = (
	id: number,
	projectFolderId: string
): Promise<{ sessionId: string; redirectUrl: string }> =>
	r({
		url: `${getBaseUrl()}/v1/credential-requests/${id}/setup-session`,
		method: 'POST',
		data: { projectFolderId },
	});

// #endregion
